var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOneTimePayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9166 14C23.9166 8.52318 19.4767 4.08334 13.9999 4.08334C8.5231 4.08334 4.08325 8.52318 4.08325 14C4.08325 19.4768 8.5231 23.9167 13.9999 23.9167C14.1299 23.9167 14.2461 23.8691 14.3581 23.7402C14.4825 23.597 14.5833 23.3636 14.5833 23.0844V21C14.5833 17.4562 17.4561 14.5833 20.9999 14.5833H23.0843C23.3636 14.5833 23.5969 14.4826 23.7401 14.3582C23.869 14.2462 23.9166 14.13 23.9166 14ZM25.6666 14C25.6666 15.3667 24.451 16.3333 23.0843 16.3333H20.9999C18.4226 16.3333 16.3333 18.4227 16.3333 21V23.0844C16.3333 24.4511 15.3666 25.6667 13.9999 25.6667C7.5566 25.6667 2.33325 20.4433 2.33325 14C2.33325 7.55668 7.5566 2.33334 13.9999 2.33334C20.4432 2.33334 25.6666 7.55668 25.6666 14Z",
    fill: "#626768"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 9.91666C14.9665 9.91666 15.75 9.13316 15.75 8.16666C15.75 7.20017 14.9665 6.41666 14 6.41666C13.0335 6.41666 12.25 7.20017 12.25 8.16666C12.25 9.13316 13.0335 9.91666 14 9.91666Z",
    fill: "#626768"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.25 12.8333C20.2165 12.8333 21 12.0498 21 11.0833C21 10.1168 20.2165 9.33334 19.25 9.33334C18.2835 9.33334 17.5 10.1168 17.5 11.0833C17.5 12.0498 18.2835 12.8333 19.25 12.8333Z",
    fill: "#626768"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 13.4167C9.7165 13.4167 10.5 12.6332 10.5 11.6667C10.5 10.7002 9.7165 9.91666 8.75 9.91666C7.7835 9.91666 7 10.7002 7 11.6667C7 12.6332 7.7835 13.4167 8.75 13.4167Z",
    fill: "#626768"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91675 19.8333C10.8832 19.8333 11.6667 19.0498 11.6667 18.0833C11.6667 17.1168 10.8832 16.3333 9.91675 16.3333C8.95025 16.3333 8.16675 17.1168 8.16675 18.0833C8.16675 19.0498 8.95025 19.8333 9.91675 19.8333Z",
    fill: "#626768"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneTimePayment);
export default __webpack_public_path__ + "static/media/one-time-payment.2c3dadeee20ac0c32df0781bfecaeb99.svg";
export { ForwardRef as ReactComponent };